import Phaser from 'phaser';
// Define a new class that extends Phaser.Scene
export default class BaseScene extends Phaser.Scene {
	// Define a constructor that takes a key parameter
	constructor(key) {
		super(key); // Call the constructor of the parent class with the key parameter
	}

	get centerX(): number {
		return this.cameras.main.centerX;
	}

	get centerY(): number {
		return this.cameras.main.centerY;
	}

	preload() {
		// Define a preload method
		// This method is empty, so it doesn't do anything
	}

	changeToScene(key, data: any = null) {
		// Define a method called changeToScene that takes a key and an optional data parameter
		// Remove all keyboard listeners
		if (this.input.keyboard) {
			this.input.keyboard.removeAllListeners();
			// Remove all input listeners
			this.input.removeAllListeners();
			// Stop all sounds (commented out)
			// this.game.sound.stopAll();
			// Pause the current scene
			this.scene.pause();
			// Check if the target scene is already paused
			if (this.scene.isPaused(key)) {
				// If it is, resume it with the data parameter
				this.scene.resume(key, data);
			} else {
				// If it isn't, launch it with the data parameter
				this.scene.launch(key, data);
			}
			// Bring the target scene to the top of the scene stack
			this.scene.bringToTop(key);
		}
	}

	centerOnResize(element: Phaser.GameObjects.GameObject, offsetX = 0, offsetY = 0) {
		const updatePosition = () => {
			const centerX = this.cameras.main.centerX + offsetX;
			const centerY = this.cameras.main.centerY + offsetY;
			if ('setPosition' in element) {
				(element as Phaser.GameObjects.GameObject & { setPosition: Function }).setPosition(centerX, centerY);
			}
		};

		this.scale.on('resize', updatePosition);
		updatePosition();
	}
}
